import React from "react";
import styles from "./index.module.scss";
// import AvatarC from "../../avatar";

export default function AvatarFlipper({
  owner
}: Readonly<{
  owner: {
    name: string;
  }[];
}>) {
  return (
    <div className={styles.FlipperVaultCardOwner}>
      {/*  */}
      <div>
        <div className={styles.FlipperVaultCardOwnerTitle}>ACCOUNT OWNER</div>
        <div className={styles.FlipperVaultCardOwnerValue}>
          {owner ? owner?.[0].name : "N/A"}
        </div>
      </div>
    </div>
  );
}
